export default "__VITE_ASSET__Bgfe$UDb__"